import * as StandardNoteField from '../standardNoteField';

import { BaseItem } from '../common';

// same as backend/src/models/note/config.ts
export enum Group {
  Default = 'DEFAULT',
  None = 'NONE',
  ObgynOb = 'OBGYN_OB',
  OrganSystems = 'ORGAN_SYSTEMS',
}

export enum Section {
  Header = 'Header',
  Dictation = 'Dictation',
  Hpi = 'HPI',
  Ros = 'ROS',
  Exam = 'Exam',
  Assessment = 'A/P',
  ProcedureDocumentation = 'Procedure Documentation',
  Billing = 'Billing',
  Internal = 'Internal',
  Footer = 'Footer',
  PatientInstructions = 'Patient Instructions',
  DiscussionNotes = 'Discussion Notes',
  OrderInterpretations = 'Order Interpretations',
  ObEpisode = 'OB Episode',
  PrenatalFlowsheet = 'Prenatal Flowsheet', // obsolete
  XRayInterpretations = 'X-Ray Interpretations',
  Previsit = 'Previsit',
}

export enum Primitive {
  String = 'STRING',
  Integer = 'INTEGER',
  Float = 'FLOAT',
  Enum = 'ENUM',
  Boolean = 'BOOLEAN',
  MultiEnum = 'MULTI_ENUM',
}

export interface NoteField extends BaseItem {
  noteId: string;
  value: string;
}

export interface NoteConfig {
  standardNoteSectionId: string | null;
  standardNoteFieldId: string | null;
  parentId: string | null;
  group: Group | StandardNoteField.Group | null;
  section: Section;
  sectionDisplayName: string | null;
  subsection: string | null;
  name: string;
  referenceName: string;
  displayName: string | null;
  primitiveType: Primitive | StandardNoteField.Primitive;
  primitive: StandardNoteField.Primitive;
  required: boolean;
  readonly: boolean;
  sectionRank: number;
  fieldRank: number;
  version?: number;
  options?: string[];
  range?: [number, number, number];
  prefix?: string;
  suffix?: string;
  hidden?: boolean;
}

// same as NoteFieldWithConfig from /backend/primary/src/models/note/field.ts
export interface NoteFieldWithConfig extends NoteField, NoteConfig {}

export const UneditableNoteSections: Section[] = [
  Section.Dictation,
  Section.ProcedureDocumentation,
  Section.Billing,
  Section.Internal,
  Section.ObEpisode,
  Section.Previsit,
];

export const NoteTemplateSections: Section[] = [
  Section.Header,
  Section.Hpi,
  Section.Ros,
  Section.Exam,
  Section.Assessment,
  Section.Footer,
  Section.DiscussionNotes,
  Section.PatientInstructions,
  Section.OrderInterpretations,
];

export const CarrySections: Section[] = [
  Section.Hpi,
  Section.Ros,
  Section.Exam,
  Section.Assessment,
  Section.DiscussionNotes,
  Section.OrderInterpretations,
];

export const SectionFields: { [key: string]: string[] } = {
  [Section.Hpi]: ['Previsit', 'HPI'],
  [Section.Ros]: [
    'ROS as in HPI',
    'Freeform',
    'Constitutional',
    'Psychiatric',
    'HEENT',
    'Cardiovascular',
    'Respiratory',
    'GI',
    'GU',
    'Musculoskeletal',
    'Integumentary',
    'Neurological',
    'Endocrine',
    'Hematologic',
    'Allergies',
  ],
  [Section.Exam]: [
    'Freeform',
    'General',
    'Psychiatric',
    'Skin',
    'Hair',
    'Nails',
    'Head',
    'Eyes',
    'Ears',
    'Nose',
    'Throat',
    'Mouth',
    'Neck',
    'Lymph Nodes',
    'Heart',
    'Lungs',
    'Abdomen',
    'Back',
    'Rectal',
    'Extremities',
    'Neurologic',
    'Pelvic',
    'Breast',
    'GU',
    'Female ',
  ],
  [Section.Assessment]: ['Freeform', 'Assessment & Plan'],
  [Section.PatientInstructions]: ['Patient Instructions'],
  [Section.DiscussionNotes]: ['Discussion Notes'],
  [Section.OrderInterpretations]: ['Freeform'],
  [Section.XRayInterpretations]: ['Name', 'Value', 'Side', 'Freeform'],
  [Section.Header]: ['Header'],
  [Section.Footer]: ['Footer', 'Mark All as Reviewed'],
};
